// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes in-btn-social{0%{left:-110%;top:90%}50%{left:10%;top:-30%}100%{top:-10%;left:-10%}}@keyframes out-btn-social{0%{top:-10%;left:-10%}50%{left:10%;top:-30%}100%{left:-110%;top:90%}}#app.de .dropdown-group-name{max-width:none}@media(max-width: 576px){#app.de .nav-item-dropdown .inner-wrapper{-moz-column-gap:clamp(30px,10vw,70px);column-gap:clamp(30px,10vw,70px);padding:4rem 2rem}}", ""]);
// Exports
module.exports = exports;
